namespace GeniuzPOS.Administration {
    export enum CsParaVatFg {
        NonVat = 0,
        Vat = 1
    }
    Serenity.Decorators.registerEnumType(CsParaVatFg, 'GeniuzPOS.Administration.CsParaVatFg', 'Administration.CsParaVatFg');
}
